import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M12.032 3a1 1 0 0 1 1 1v14.624l5.276-5.063a1 1 0 0 1 1.384 1.443l-7 6.717a1 1 0 0 1-1.384 0l-7-6.717a1 1 0 1 1 1.384-1.443l5.34 5.124V4a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
